module.exports = __webpack_public_path__ + "static/media/nissan-logo.fa3d10e2.svg";